import type { TEnvironment } from "./types";

export const staging: TEnvironment = {
  production: false,
  env: "staging",
  base: "https://editor-staging.storydoc.com",
  backend: "https://app-staging.storydoc.com/api",
  // backend: "http://localhost:3000/api",
  stories: "https://www-staging.storydoc.com",
  assets: "https://www-staging.storydoc.com/assets/editor",
  featureFlagsCdnUrl:
    "https://www-staging.storydoc.com/assets/json/feature-flags.json",
  oktaAppId: "0oa4hp85crSg96e4I5d6",
  securedBucket: "secured-poc",
  assetsLink: "https://editor-bundle-staging.storydoc.com",
  // assetsLink: "http://localhost:3000",
  mixpanel: "97d8ed158b18e01de0155b8eb903b7f3",
  pdfBackend: "https://headless-service-t577tuu5xq-ew.a.run.app",
  generationBackend:
    "https://presentation-generation-728346048498.europe-west1.run.app/presentation-generation",
  frontPublicUrl: "https://www-staging.storydoc.com/assets/editor-staging",
  files: "storydoc-files-staging",
  acceptButton: "https://seal-t577tuu5xq-ew.a.run.app/v2/seal",
  assetsBucket: "assets-staging.storydoc.com",
  emailValidationEndpoint: "https://website-t577tuu5xq-ew.a.run.app/validate",
  turnstileSiteKey: "0x4AAAAAAAL4-LuW6xeAOp_E",
  hocuspocusUrl: "wss://hocuspocus-728346048498.europe-west1.run.app",
  legacyUrl: "https://app-staging.storydoc.com/",
  mcpUrl: "https://storydoc-mcp-728346048498.europe-west1.run.app",
  firebaseConfig: {
    apiKey: "AIzaSyDkAQdusdq_4YdSCEqB2RxivpEvM4Qa4ZA",
    authDomain: "platform-staging-303007.firebaseapp.com",
    projectId: "platform-staging-303007",
  },
  paddle: {
    vendorId: 2373,
    designerAdviceProductId: 12537,
    additionalSeatsSubsId: 35915,
    plans: [
      {
        period: "Monthly",
        title: "Pro",
        price: 60,
        id: "12528",
        seats: 1,
        seatPrice: 60,
        active: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 432,
        id: "73754",
        seats: 1,
        seatPrice: 432,
        active: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 288,
        id: "73754",
        seats: 1,
        seatPrice: 288,
        earlyBird: true,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 360,
        id: "73413",
        seats: 1,
        seatPrice: 360,
      },
      {
        period: "Annually",
        title: "Pro",
        price: 540,
        id: "13311",
        seats: 1,
        seatPrice: 540,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 50,
        id: "12527",
        seats: 1,
        seatPrice: 50,
        legacy: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "13310",
        seats: 1,
        seatPrice: 360,
        legacy: true,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 40,
        id: "39729",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 20,
        id: "78644",
        seats: 1,
        seatPrice: 20,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 25,
        id: "82350",
        seats: 1,
        seatPrice: 25,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 29,
        id: "83291",
        seats: 1,
        seatPrice: 29,
      },
      {
        period: "Monthly",
        title: "Starter",
        price: 33,
        id: "87070",
        seats: 1,
        seatPrice: 33,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 360,
        id: "39730",
        seats: 1,
        seatPrice: 360,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 240,
        id: "73412",
        seats: 1,
        seatPrice: 240,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 288,
        id: "73755",
        seats: 1,
        seatPrice: 288,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 144,
        id: "78645",
        seats: 1,
        seatPrice: 144,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 180,
        id: "82351",
        seats: 1,
        seatPrice: 180,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 208,
        id: "83292",
        seats: 1,
        seatPrice: 208,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 237.6,
        id: "87071",
        seats: 1,
        seatPrice: 237.6,
        active: true,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 96,
        id: "79414",
        seats: 1,
        seatPrice: 96,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 139,
        id: "83292",
        seats: 1,
        seatPrice: 139,
      },
      {
        period: "Annually",
        title: "Starter",
        price: 158.4,
        id: "87071",
        seats: 1,
        seatPrice: 158.4,
        earlyBird: true,
      },
      {
        period: "Monthly",
        title: "Premium",
        price: 500,
        id: "13313",
        seats: 15,
        seatPrice: 500,
        active: true,
      },
      {
        period: "Annually",
        title: "Premium",
        price: 4800,
        id: "13314",
        seats: 15,
        seatPrice: 4800,
        active: true,
      },
      {
        period: "Annually",
        title: "Premium",
        price: 720,
        id: "83322",
        seats: 1,
        seatPrice: 720,
        active: true,
      },
    ],
  },
  appSumo: {
    plans: [
      {
        period: "Lifetime",
        title: "AppSumo License Tier 1 Lifetime plan",
        price: 69,
        id: "storydoc_tier1",
        seats: 1,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 2 Lifetime plan",
        price: 149,
        id: "storydoc_tier2",
        seats: 5,
        seatPrice: 40,
      },
      {
        period: "Lifetime",
        title: "AppSumo License Tier 3 Lifetime plan",
        price: 309,
        id: "storydoc_tier3",
        seats: 15,
        seatPrice: 40,
      },
    ],
  },
};
